module.exports = __webpack_public_path__ + "img/menu-icon.09cdab9c.svg";